type Options = { message?: string };

const useConfirm = ({ message = '정말 할까요?' }: Options) => {
  const confirm = () => window.confirm(message);
  return { confirm };
};

export default useConfirm;
export type { Options as UseConfirmOptions };
